<template>
  <div class="card_bar_container topView" > <!--v-if="cardShow && cardTitle !== ''"-->
    <div class="card_bar_title" @click="toggleContent">
      <div class="card_bar_title_text"> {{ cardTitle }} </div><!--优惠活动-->
      <van-icon name="arrow-up" class="icon_arrow" v-if="isShowContent"/>
      <van-icon name="arrow-down" class="icon_arrow" v-if="!isShowContent"/>
    </div>


  </div>
</template>

<script>

export default {
  name: "TopToolBar",
  props: {
    isShowContent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContent: true,

    };
  },
  computed: {
    cardShow() {
      return typeof this.$store.state?.vuex_cardInfo?.title !== 'undefined';
    },
    cardTitle() {
      return this.$store.state?.vuex_cardInfo?.title || '';
    },
    cardContent(){
      return this.$store.state?.vuex_cardInfo?.content || '';
    }

  },
  mounted () {
  },

  methods: {
    toggleContent() {
      this.$emit('toggleContent')
    },
  },
};
</script>

<style lang="less" scoped>
  .card_bar_container{
    position: absolute;
    float: left;
    width: 91px;
    // height: 81px;
    background: rgba(0, 0, 0, 0.3);
    // border-radius: 6px;

    top: 74px; // 12 + 50 + 12
    left: 16px;

    // padding: 0 10px;
    color: #fff;
    text-align: center;
    font-size: 12px;
    line-height: 1;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;


  }
  .topView{
    z-index: 48; // 避免被输入条覆盖
    /*transform: translateZ(2px); !*这里是给safari用的z-index*!
    -webkit-transform:translateZ(px);
    -moz-transform:translateZ(2px);
    -o-transform:translateZ(2px);*/
  }

  .card_bar_title{
    float: left;
    width: 91px;
    height: 28px;
    font-weight: 600;
    font-size: 13px;
    line-height: 13px;
    letter-spacing: 1px;
    text-align: left;
    font-style: normal;

    box-sizing: border-box;
    padding: 0 5px 0 8px;
    display: flex;
    align-items: center;

    .card_bar_title_text{
      float: left;
      width: 60px;

      background-image: linear-gradient( to right, #FF9231 0%, #FF5077 100%); /* 定义渐变颜色 */
      -webkit-background-clip: text; /* 在 WebKit 浏览器中设置文字作为背景裁剪 */
      background-clip: text; /* 设置文字作为背景裁剪 */
      color: transparent; /* 将文字颜色设为透明 */
    }
    .icon_arrow{
      float: left;
      font-size: 12px;
      width: 10px;

    }

  }
</style>
